/*eslint-disable*/
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Stack,
  TextField,
  useMediaQuery,
  useTheme,
  Typography,
  Divider,
  Avatar,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../theme";
// import { mockDataContacts } from "../../data/mockData";

import Header from "../../components/Header";
import { useSelector } from "react-redux";
import {
  addNewBooking,
  listAllRooms,
  resetAllBookingsData,
  listAllBookings,
  resetAllRoomsList,
  fetchAllGroups,
} from "../../store/actions";
import { useDispatch } from "react-redux";
import { Formik } from "formik";
import { Add, ExpandMore, ChevronRight } from "@mui/icons-material";
import * as yup from "yup";

// Helper function to get all unique user IDs from both groups and individual users
const getAllUserIds = (rooms, groups) => {
  const allUserIds = new Set();
  
  // Add users from groups
  groups.forEach(group => {
    group.users.forEach(user => {
      allUserIds.add(user._id);
    });
  });
  
  // Add individual users (rooms list) - but only if they're not already in groups
  const usersInGroups = new Set();
  groups.forEach(group => {
    group.users.forEach(user => {
      usersInGroups.add(user._id);
    });
  });
  
  rooms?.list?.forEach(user => {
    if (!usersInGroups.has(user._id)) {
      allUserIds.add(user._id);
    }
  });
  
  console.log('getAllUserIds - All unique user IDs:', Array.from(allUserIds));
  return Array.from(allUserIds);
};

// Helper functions for Select All functionality
const isAllSelected = (rooms, groups, roomsBooked) => {
  const allUserIds = getAllUserIds(rooms, groups);
  const isAll = allUserIds.length > 0 && roomsBooked.length === allUserIds.length && 
                allUserIds.every(id => roomsBooked.includes(id));
  console.log('isAllSelected check:', { 
    allUserIds: allUserIds.length, 
    roomsBooked: roomsBooked.length, 
    isAll,
    allIds: allUserIds,
    selected: roomsBooked
  });
  return isAll;
};

const handleSelectAll = (rooms, groups, roomsBooked, setRoomsBooked) => {
  const allUserIds = getAllUserIds(rooms, groups);
  console.log('handleSelectAll - All user IDs to select:', allUserIds);
  
  if (isAllSelected(rooms, groups, roomsBooked)) {
    // If all are selected, deselect all
    console.log('Deselecting all users');
    setRoomsBooked([]);
  } else {
    // If not all are selected, select all
    console.log('Selecting all users:', allUserIds);
    setRoomsBooked(allUserIds);
  }
};

// Helper function to check if all users in a group are selected
const isGroupFullySelected = (group, roomsBooked) => {
  return group.users.every(user => roomsBooked.includes(user._id));
};

// Helper function to check if some users in a group are selected
const isGroupPartiallySelected = (group, roomsBooked) => {
  return group.users.some(user => roomsBooked.includes(user._id)) && 
         !isGroupFullySelected(group, roomsBooked);
};

// Helper function to handle group selection
const handleGroupSelection = (group, roomsBooked, setRoomsBooked) => {
  const groupUserIds = group.users.map(user => user._id);
  
  if (isGroupFullySelected(group, roomsBooked)) {
    // If all users in group are selected, deselect them
    setRoomsBooked(prev => prev.filter(userId => !groupUserIds.includes(userId)));
  } else {
    // If not all users in group are selected, select all of them
    setRoomsBooked(prev => {
      const newSelected = [...prev];
      groupUserIds.forEach(userId => {
        if (!newSelected.includes(userId)) {
          newSelected.push(userId);
        }
      });
      return newSelected;
    });
  }
};

// Helper function to get users that are not in any group
const getUsersNotInGroups = (allUsers, groups) => {
  const usersInGroups = new Set();
  groups.forEach(group => {
    group.users.forEach(user => {
      usersInGroups.add(user._id);
    });
  });
  
  return allUsers.filter(user => !usersInGroups.has(user._id));
};

const Bookings = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const smScreen = useMediaQuery(theme.breakpoints.up("sm"));
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [roomsBooked, setRoomsBooked] = useState([]);
  const [selectedAds, setSelectedAds] = useState([]);
  const [expandedGroups, setExpandedGroups] = useState(new Set());
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setSelectedAds([]); // Reset selected ads when closing modal
  };

  const { isLoading, bookingsList, rooms, showViewMore } = useSelector(
    ({
      loading,
      admin: {
        bookings: { list, showViewMore },
        rooms,
      },
    }) => ({
      isLoading: loading,
      bookingsList: list,
      showViewMore,
      rooms,
    })
  );

  useEffect(() => {
    dispatch(resetAllBookingsData());
    dispatch(resetAllRoomsList());
    fetchMoreData();
    dispatch(fetchAllGroups());
  }, []);

  const fetchMoreData = () => {
    dispatch(listAllBookings());
    dispatch(listAllRooms());
  };

  const groups = useSelector((state)=>state?.admin?.userGroups?.list || [])
  const ads = useSelector((state)=> state?.admin?.ads.list)
  console.log(ads, 'adddd')

  // Get users not in any group
  const usersNotInGroups = getUsersNotInGroups(rooms?.list || [], groups);
  
  // Debug logging
  const allUserIds = getAllUserIds(rooms, groups);

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: smScreen ? 400 : "90%",
    bgcolor: "#1F2A40",
    outline: "none",
    boxShadow: 24,
    p: 2,
  };

  const handleFormSubmit = async (values) => {
    let data = {
      ...values,
      users: roomsBooked,
      ads: selectedAds,
    };

    await dispatch(addNewBooking(data));
    setRoomsBooked([]);
    setSelectedAds([]);
    handleClose();
  };

  const initialValues = {
    // name: "",
    // email: "",
    // totalPrice: 0,
  };

  const checkoutSchema = yup.object().shape({
    // name: yup.string().required("Required"),
    // email: yup.string().email("Invalid email").required("Required"),
  });

  const columns = [
    { field: "_id", headerName: "Game Id", width: 250 },
    {
      field: "status",
      headerName: "Status",
      width: 100,
    },
  ];

  // Handle individual user selection
  const handleUserSelection = (userId) => {
    setRoomsBooked(prev => {
      if (prev.includes(userId)) {
        return prev.filter(id => id !== userId);
      } else {
        return [...prev, userId];
      }
    });
  };

  // Handle group expansion/collapse
  const toggleGroupExpansion = (groupId) => {
    setExpandedGroups(prev => {
      const newSet = new Set(prev);
      if (newSet.has(groupId)) {
        newSet.delete(groupId);
      } else {
        newSet.add(groupId);
      }
      return newSet;
    });
  };

  // Handle ad selection
  const handleAdSelection = (adId) => {
    setSelectedAds(prev => {
      if (prev.includes(adId)) {
        return prev.filter(id => id !== adId);
      } else {
        return [...prev, adId];
      }
    });
  };

  // Handle select all ads
  const handleSelectAllAds = () => {
    if (!ads || ads.length === 0) return;
    
    if (selectedAds.length === ads.length) {
      // If all are selected, deselect all
      setSelectedAds([]);
    } else {
      // If not all are selected, select all
      setSelectedAds(ads.map(ad => ad.id));
    }
  };

  // Check if all ads are selected
  const isAllAdsSelected = () => {
    return ads && ads.length > 0 && selectedAds.length === ads.length;
  };

  return (
    <Box m="20px">
      <Box
        display={smScreen ? "flex" : "block"}
        flexDirection={smScreen ? "row" : "column"}
        justifyContent={smScreen ? "space-between" : "start"}
        alignItems={smScreen ? "center" : "start"}
        m="20px 0"
      >
        <Header title="GAMES" subtitle="welcome to Games" />

        <Box>
          <Button
            sx={{
              backgroundColor: colors.blueAccent[700],
              color: colors.grey[100],
              fontSize: "14px",
              fontWeight: "bold",
              padding: "10px 20px",
            }}
            onClick={handleOpen}
          >
            <Add sx={{ mr: "10px" }} />
            Host a game
          </Button>
        </Box>
      </Box>
      <Box
        m="8px 0 0 0"
        width="100%"
        height="80vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        <DataGrid
          rows={bookingsList}
          columns={columns}
          components={{ Toolbar: GridToolbar }}
          getRowId={(row) => row?._id}
        />
      </Box>

      <Modal open={open} onClose={handleClose}>
        <Box sx={modalStyle}>
          <Header title="HOST A GAME" titleVariant="h4" />

          <Formik
            onSubmit={handleFormSubmit}
            initialValues={initialValues}
            validationSchema={checkoutSchema}
          >
            {({
              values,
              errors,
              touched,
              handleBlur,
              handleChange,
              handleSubmit,
            }) => (
              <form onSubmit={handleSubmit}>
                <Stack spacing={2}>
                  {/* Ads Selection */}
                  <FormControl size="small" fullWidth>
                    <InputLabel>Select Games/Ads</InputLabel>
                    <Select
                      multiple
                      value={selectedAds}
                      label="Games/Ads"
                      onChange={() => {}} // Controlled by custom handlers
                      renderValue={(selected) => {
                        if (selected.length === 0) return "";
                        if (ads && selected.length === ads.length)
                          return "All ads selected";
                        return `${selected.length} ad${
                          selected.length > 1 ? "s" : ""
                        } selected`;
                      }}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 300,
                            overflow: 'auto',
                          },
                        },
                      }}
                    >
                      {/* Select All Ads MenuItem */}
                      <MenuItem
                        onClick={(e) => {
                          e.stopPropagation();
                          handleSelectAllAds();
                        }}
                        sx={{
                          backgroundColor: colors.blueAccent[800],
                          "&:hover": {
                            backgroundColor: colors.blueAccent[700],
                          },
                          borderBottom: `1px solid ${colors.grey[700]}`,
                          marginBottom: "4px",
                        }}
                      >
                        <Checkbox
                          checked={isAllAdsSelected()}
                          indeterminate={
                            selectedAds.length > 0 &&
                            selectedAds.length < (ads?.length || 0)
                          }
                        />
                        <Box sx={{ fontWeight: "bold" }}>
                          {isAllAdsSelected()
                            ? "Deselect All Ads"
                            : "Select All Ads"}
                        </Box>
                      </MenuItem>

                      {ads && ads.length > 0 ? (
                        ads.map((ad) => (
                          <MenuItem 
                            key={ad.id} 
                            onClick={(e) => {
                              e.stopPropagation();
                              handleAdSelection(ad.id);
                            }}
                            sx={{
                              backgroundColor: colors.primary[700],
                              "&:hover": {
                                backgroundColor: colors.primary[600],
                              },
                              "&.Mui-selected": {
                                backgroundColor: colors.blueAccent[700],
                                "&:hover": {
                                  backgroundColor: colors.blueAccent[600],
                                },
                              },
                              display: 'flex',
                              alignItems: 'center',
                              padding: '12px 16px',
                              minHeight: '60px',
                            }}
                          >
                            <Checkbox 
                              checked={selectedAds.includes(ad.id)}
                              size="small"
                              sx={{ marginRight: 1 }}
                            />
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                              {/* Media Preview */}
                              <Box sx={{ flexShrink: 0 }}>
                                {ad.media_type === 'image' ? (
                                  <Avatar
                                    src={ad.media_url}
                                    alt={ad.name}
                                    sx={{ 
                                      width: 40, 
                                      height: 40,
                                      border: `2px solid ${colors.greenAccent[500]}`,
                                    }}
                                    variant="rounded"
                                  />
                                ) : ad.media_type === 'video' ? (
                                  <Box
                                    sx={{
                                      width: 40,
                                      height: 40,
                                      backgroundColor: colors.blueAccent[700],
                                      border: `2px solid ${colors.greenAccent[500]}`,
                                      borderRadius: 1,
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      fontSize: '12px',
                                      fontWeight: 'bold',
                                      color: colors.grey[100],
                                    }}
                                  >
                                    📹
                                  </Box>
                                ) : (
                                  <Avatar
                                    sx={{ 
                                      width: 40, 
                                      height: 40,
                                      backgroundColor: colors.grey[700],
                                      border: `2px solid ${colors.greenAccent[500]}`,
                                    }}
                                    variant="rounded"
                                  >
                                    🎮
                                  </Avatar>
                                )}
                              </Box>
                              
                              {/* Ad Details */}
                              <Box sx={{ flex: 1, minWidth: 0 }}>
                                <Typography 
                                  variant="body1" 
                                  sx={{ 
                                    fontWeight: 'bold',
                                    color: colors.grey[100],
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  {ad.name}
                                </Typography>
                                <Typography 
                                  variant="body2" 
                                  sx={{ 
                                    color: colors.grey[300],
                                    fontSize: '12px',
                                    textTransform: 'uppercase',
                                  }}
                                >
                                  {ad.media_type} • {new Date(ad.createdAt).toLocaleDateString()}
                                </Typography>
                              </Box>
                            </Box>
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem disabled>
                          <Typography variant="body2" sx={{ color: colors.grey[500] }}>
                            No ads available
                          </Typography>
                        </MenuItem>
                      )}
                    </Select>
                  </FormControl>

                  {/* Users Selection */}
                  <FormControl size="small" fullWidth>
                    <InputLabel>Select Users</InputLabel>
                    <Select
                      multiple
                      value={roomsBooked}
                      label="Users"
                      onChange={() => {}} // Controlled by custom handlers
                      renderValue={(selected) => {
                        if (selected.length === 0) return "";
                        const totalUsers = getAllUserIds(rooms, groups).length;
                        if (selected.length === totalUsers)
                          return "All users selected";
                        return `${selected.length} user${
                          selected.length > 1 ? "s" : ""
                        } selected`;
                      }}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 400,
                            overflow: 'auto',
                          },
                        },
                      }}
                    >
                      {/* Select All MenuItem */}
                      <MenuItem
                        onClick={(e) => {
                          e.stopPropagation();
                          handleSelectAll(rooms, groups, roomsBooked, setRoomsBooked);
                        }}
                        sx={{
                          backgroundColor: colors.blueAccent[800],
                          "&:hover": {
                            backgroundColor: colors.blueAccent[700],
                          },
                          borderBottom: `1px solid ${colors.grey[700]}`,
                          marginBottom: "4px",
                        }}
                      >
                        <Checkbox
                          checked={isAllSelected(rooms, groups, roomsBooked)}
                          indeterminate={
                            roomsBooked.length > 0 &&
                            roomsBooked.length < getAllUserIds(rooms, groups).length
                          }
                        />
                        <Box sx={{ fontWeight: "bold" }}>
                          {isAllSelected(rooms, groups, roomsBooked)
                            ? "Deselect All"
                            : "Select All"}
                        </Box>
                      </MenuItem>

                      {/* Groups Section */}
                      {groups.length > 0 && (
                        <>
                          <MenuItem disabled sx={{ opacity: 0.6, fontWeight: "bold" }}>
                            <Typography variant="body2" sx={{ color: colors.grey[300] }}>
                              GROUPS
                            </Typography>
                          </MenuItem>
                          
                          {groups.map((group) => (
                            <Box key={group._id}>
                              {/* Group Header */}
                              <MenuItem
                                sx={{
                                  backgroundColor: colors.blueAccent[700],
                                  "&:hover": {
                                    backgroundColor: colors.blueAccent[600],
                                  },
                                  borderLeft: `4px solid ${colors.greenAccent[500]}`,
                                  display: 'flex',
                                  alignItems: 'center',
                                  padding: '8px 16px',
                                }}
                              >
                                {/* Expand/Collapse Icon */}
                                <Box
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    toggleGroupExpansion(group._id);
                                  }}
                                  sx={{
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    marginRight: '8px',
                                    minWidth: '24px',
                                  }}
                                >
                                  {expandedGroups.has(group._id) ? (
                                    <ExpandMore fontSize="small" />
                                  ) : (
                                    <ChevronRight fontSize="small" />
                                  )}
                                </Box>

                                {/* Group Checkbox */}
                                <Checkbox
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleGroupSelection(group, roomsBooked, setRoomsBooked);
                                  }}
                                  checked={isGroupFullySelected(group, roomsBooked)}
                                  indeterminate={isGroupPartiallySelected(group, roomsBooked)}
                                  size="small"
                                />
                                
                                {/* Group Name */}
                                <Typography 
                                  variant="body2" 
                                  sx={{ 
                                    ml: 1, 
                                    fontWeight: "bold",
                                    flex: 1,
                                    cursor: 'pointer'
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    toggleGroupExpansion(group._id);
                                  }}
                                >
                                  📁 {group.name} ({group.users.length} users)
                                </Typography>
                              </MenuItem>

                              {/* Group Users - Only show when expanded */}
                              {expandedGroups.has(group._id) && group.users.map((user) => (
                                <MenuItem
                                  key={user._id}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleUserSelection(user._id);
                                  }}
                                  sx={{
                                    backgroundColor: colors.primary[700],
                                    "&:hover": {
                                      backgroundColor: colors.primary[600],
                                    },
                                    paddingLeft: "48px", // Indent group users more
                                    borderLeft: `2px solid ${colors.grey[600]}`,
                                    marginLeft: "16px",
                                  }}
                                >
                                  <Checkbox 
                                    checked={roomsBooked.includes(user._id)}
                                    size="small"
                                  />
                                  <Typography variant="body2" sx={{ ml: 1 }}>
                                    👤 {user.username}
                                  </Typography>
                                </MenuItem>
                              ))}
                            </Box>
                          ))}
                          
                          {usersNotInGroups.length > 0 && (
                            <Divider sx={{ my: 1, backgroundColor: colors.grey[600] }} />
                          )}
                        </>
                      )}

                      {/* Individual Users (not in any group) */}
                      {usersNotInGroups.length > 0 && (
                        <>
                          <MenuItem disabled sx={{ opacity: 0.6, fontWeight: "bold" }}>
                            <Typography variant="body2" sx={{ color: colors.grey[300] }}>
                              INDIVIDUAL USERS
                            </Typography>
                          </MenuItem>
                          
                          {usersNotInGroups.map((user) => (
                            <MenuItem
                              key={user._id}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleUserSelection(user._id);
                              }}
                              sx={{
                                backgroundColor: colors.primary[700],
                                "&:hover": {
                                  backgroundColor: colors.primary[600],
                                },
                              }}
                            >
                              <Checkbox 
                                checked={roomsBooked.includes(user._id)}
                                size="small"
                              />
                              <Typography variant="body2" sx={{ ml: 1 }}>
                                👤 {user.username}
                              </Typography>
                            </MenuItem>
                          ))}
                        </>
                      )}
                    </Select>
                  </FormControl>

                  <Button
                    fullWidth
                    size="large"
                    type="submit"
                    color="secondary"
                    variant="contained"
                    sx={{ fontSize: "15px" }}
                  >
                    {isLoading ? (
                      <CircularProgress color="inherit" size={24} />
                    ) : (
                      <b>Submit</b>
                    )}
                  </Button>
                </Stack>
              </form>
            )}
          </Formik>
        </Box>
      </Modal>
    </Box>
  );
};

export default Bookings;